import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.find.js";
import draggable from "vuedraggable";
import Goods from "./Goods";
export default {
    props: {
        modelValue: {
            type: Array,
            default: ()=>[]
        }
    },
    components: {
        Goods,
        draggable
    },
    data () {
        return {
            dialog: {
                save: false
            },
            value: []
        };
    },
    watch: {
        modelValue: {
            handler (val) {
                if (val) {
                    this.value = val;
                }
            },
            deep: true,
            immediate: true
        },
        value (val) {
            this.$emit("update:modelValue", val);
        }
    },
    computed: {
        previewSrcList ({ value }) {
            return value.map((item)=>item.image);
        }
    },
    methods: {
        findObjectById (id) {
            return this.allItems.find((item)=>item.id === id);
        },
        choose () {
            this.dialog.save = true;
            this.$nextTick(()=>{
                this.$refs.GoodsDialog.open();
            });
        },
        handleSuccess (data) {
            this.value = data;
        },
        deleteData (index) {
            this.value.splice(index, 1);
        }
    }
};
